<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card color="#1565c0" tile flat>
            <v-list flat color="#004889" class="py-0 d-flex flex-wrap">
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Select a Size</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.size"
                            :items="sizes"
                            item-text="title"
                            item-value="id"
                            data-vv-name="size"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.status"
                            :items="statuses"
                            item-text="label"
                            item-value="value"
                            required
                            :error-messages="errors"
                            solo
                            flat
                            dark
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Select a Shape</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.shape"
                            :items="shapes"
                            item-text="title"
                            item-value="id"
                            data-vv-name="shape"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Pool Addons</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.option"
                            :items="options"
                            item-text="title"
                            item-value="id"
                            small-chips
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        >
                        </v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Liner Pattern</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.liner_color"
                            :items="liner_color"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Extra Concrete</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.extra_concrete"
                            :items="yes_no"
                            item-text="label"
                            item-value="value"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Retaining Wall</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.retaining_wall"
                            :items="yes_no"
                            item-text="label"
                            item-value="value"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                            <v-text-field
                                v-model="form_pools.city"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                            ></v-text-field>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">County</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                            <v-autocomplete
                                :items="counties"
                                :filter="customFilter"
                                :error-messages="errors"
                                v-model="form_pools.county"
                                color="white"
                                item-text="title"
                                item-value="id"
                                label="County"
                                required
                                solo
                                flat
                                dark
                                clearable
                            ></v-autocomplete>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">From Date</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-menu
                            v-model="menustartpool"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedStartDateFormatted"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                solo
                                flat
                                dark
                                clearable
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="form_pools.start_date"
                            @input="menustartpool = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">End Date</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-menu
                            v-model="menuendpool"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedEndDateFormatted"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                solo
                                flat
                                dark
                                clearable
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="form_pools.end_date"
                            @input="menuendpool = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Supervisor</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.supervisor"
                            :items="users"
                            item-text="name"
                            item-value="id"
                            label="Supervisor"
                            clearable
                            solo
                            flat
                            dark
                            hide-details
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Group By</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_pools.group_by"
                            :items="group_by"
                            item-text="label"
                            item-value="value"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        >
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row">
                    <v-list-item-content class="label">
                    
                    </v-list-item-content>
                    <v-list-item-action class="justify-end">
                        <v-btn
                            color="#ffffff"
                            class="primary--text"
                            tile
                            large
                            @click="getResultsPools"
                            :loading="loading"
                            >
                                Generate
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="pa-0 w-100">
                    <v-list-item-content class="pa-0">
                        <v-card v-if="results_pools.total" color="#003a6f" flat tile>
                            <v-card-text class="d-flex flex-wrap align-center">
                                <v-chip-group
                                    active-class="deep-purple accent-4 white--text"
                                    column
                                >
                                    <v-chip
                                    >
                                        Pools: {{ results_pools.total }}
                                    </v-chip>
                                    <v-chip
                                    >
                                        Total Amount: {{ results_pools.sum | currency }}
                                    </v-chip>
                                </v-chip-group>
                                <v-spacer></v-spacer>
                                <downloadexcel
                                    class            = "btn"
                                    :fetch           = "fetchData"
                                    :fields          = "json_fields"
                                    :before-generate = "startDownload"
                                    :before-finish   = "finishDownload"
                                    name="export.xls"
                                    v-if="results_pools.total > 0"
                                    >
                                    <v-btn
                                        color="#ffffff"
                                        class="primary--text"
                                        tile
                                        small
                                        :loading="downloadLoading"
                                        >
                                            Export
                                    </v-btn>
                                </downloadexcel>
                            </v-card-text>
                        </v-card>
                        <v-data-table
                            :headers="headers_groups"
                            :items="results_pools.stats"
                            :items-per-page="100"
                            class="elevation-1"
                            mobile-breakpoint="0"
                            v-if="results_pools.stats.length"
                        >
                            <template v-slot:item.percentage="props">
                                {{ props.item.percentage + '%' }}
                            </template>                                   
                        </v-data-table>
                        <v-data-table
                            :headers="headers_pools"
                            :items="results_pools.data"
                            :items-per-page="100"
                            class="elevation-1"
                            mobile-breakpoint="0"
                            v-else
                        >
                            <template v-slot:item.job_no="props">
                                <router-link
                                    :to="`/job/main/${props.item.id}`"  target="_blank"
                                >
                                    <NavLink>{{ props.item.job_no }}</NavLink>
                                </router-link>
                            </template>
                            <template v-slot:item.customer="props">
                                <router-link
                                    :to="`/customer/${props.item.customer.id}`"  target="_blank"
                                >
                                    <NavLink>{{ props.item.customer.first_name + ' ' + props.item.customer.last_name }}</NavLink>
                                </router-link>
                            </template>
                            <template v-slot:item.customer.county="props">
                                {{ getCountyName(props.item.customer.county) }}
                            </template>
                            <template v-slot:item.start_date="props">
                                {{ formatDate(props.item.start_date) }}
                            </template>
                            <template v-slot:item.completed_date="props">
                                {{ formatDate(props.item.completed_date) }}
                            </template>
                            <template v-slot:item.contract_amount="props">
                                {{ props.item.contract_amount | currency }}
                            </template>
                            <template v-slot:item.status="props">
                                <v-chip
                                color="green"
                                text-color="white"
                                v-if="props.item.status == 'completed'"
                                >
                                Completed
                                </v-chip>
                                <v-chip
                                color="primary"
                                text-color="white"
                                v-else-if="props.item.status == 'active'"
                                >
                                Active
                                </v-chip>
                                <v-chip
                                color="grey"
                                text-color="white"
                                v-else-if="props.item.status == 'archived'"
                                >
                                Archived
                                </v-chip>
                                <v-chip
                                color="red"
                                text-color="white"
                                v-else-if="props.item.status == 'cancelled'"
                                >
                                Cancelled
                                </v-chip>
                            </template>                                     
                        </v-data-table>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import mixin from '../../mixin/main.js'
    import axios from 'axios'
    import downloadexcel from "vue-json-excel"

    export default {
        mixins: [mixin],
        data () {
            return {
                date: new Date().toISOString().substr(0, 10),
                menustartpool: false,
                menuendpool: false,
                form_pools: {
                    size: '',
                    shape: '',
                    start_date: '',
                    end_date: '',
                    status: 'all',
                    liner_color: '',
                    extra_concrete: '',
                    retaining_wall: '',
                    option: '',
                    city: '',
                    county: '',
                    supervisor: '',
                    group_by: ''
                },
                results_pools: {
                    data: [],
                    total: '',
                    sum: '',
                    stats: []
                },
                loading: false,
                headers_pools: [
                    { text: 'Job #', align: 'start', sortable: false, value: 'job_no' },
                    { text: 'Customer', align: 'start', sortable: false, value: 'customer' },
                    { text: 'City', value: 'customer.city' },
                    { text: 'County', value: 'customer.county' },
                    { text: 'Price', value: 'contract_amount' },
                    { text: 'Status', value: 'status' },
                    { text: 'Start Date', value: 'start_date', sortable: false  },
                    { text: 'Completed Date', value: 'completed_date', sortable: false },
                ],
                headers_groups: [
                    { text: 'Source', align: 'start', sortable: false, value: 'label' },
                    { text: 'No. of entries', value: 'value' },
                    { text: 'Percentage', value: 'percentage' },
                ],
                yes_no: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                ],
                group_by: [
                    { label: 'Source', value: 'how_did_your_hear' },
                    { label: 'County', value: 'county' },
                    { label: 'Zone', value: 'zone' },
                    { label: 'Size', value: 'size' },
                    { label: 'Shape', value: 'shape' },
                ],
                downloadLoading: false,
                json_fields: {
                    'Job No': 'job_no',
                    'Customer Name': 'customer_name',
                    'Address': 'address',
                    'Price': 'price',
                    'Status': 'status',
                    'Start Date': 'start_date',
                    'Completed Date': 'completed_date'
                },
            }
        },
        components: {
            downloadexcel,
        },
        created() {
            this.pageTitle = this.$route.meta.title
        },
        computed: {
            ...mapGetters({
                sizes: 'data/sizes',
                shapes: 'data/shapes',
                options: 'data/options',
                statuses: 'data/jobStatusArray',
                liner_color: 'data/liner_color',
                counties: 'data/counties',
                leadStatuses: 'data/statusArray',
                users: 'data/users',
            }),
            computedStartDateFormatted () {
                return this.formatDate(this.form_pools.start_date)
            },
            computedEndDateFormatted () {
                return this.formatDate(this.form_pools.end_date)
            },
        },
        methods: {
            getResultsPools() {
                this.loading = true
                axios.post('crm/report/pools', this.form_pools)
                    .then((response) => {
                        this.loading = false
                        this.results_pools = response.data
                        this.$nextTick()
                    })
            },
            customFilter (item, queryText) {
                const textOne = item.title.toLowerCase()
                const searchText = queryText.toLowerCase()

                return textOne.indexOf(searchText) > -1
            },
            getCountyName(county) {
                let cty = this.counties.filter(c => {
                    return c.id == county
                })

                if(cty.length) {
                    return cty[0].title
                }
            },
            async fetchData(){
                const response = await axios.get('crm/jobs/export_report', {
                    params: this.form_pools
                });
                console.log(response);
                return response.data;
            },
            startDownload(){
                this.downloadLoading = true
            },
            finishDownload(){
                this.downloadLoading = false
            }
        }
    }
</script>

<style lang="sass">
.w-100
    width: 100%

@media only screen and (min-width: 600px)
    .form-row
        &.half 
            max-width: 50%

        &.third
            max-width: 33.33%
</style>